import { FC } from "react";
import { TaskAssignmentPayload } from "tm-shared/types";

import { StyledBlock, StyledTextArea } from "../../Styled";

interface TextProps {
    payload?: TaskAssignmentPayload;
    onChangeComment: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export const Text: FC<TextProps> = ({ payload, onChangeComment }) => {
    return (
        <StyledBlock>
            <StyledTextArea
                placeholder="Введіть коментар"
                rows={6}
                value={payload?.comment ?? ""}
                onChange={onChangeComment}
            />
        </StyledBlock>
    );
};
